import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import { errorMessage } from '@features/applications';
import {
  boostSocialRoute,
  enterpriseBoostLocationRoute,
  enterpriseBoostSocialRoute,
} from '@features/boostMyJobs/api/constants';
import axiosInstance from '@server/axiosInstance';
import { paymentDetails } from '@features/payments';

type useEnterpriseBoostSocialProps = {
  setErrorText: Dispatch<SetStateAction<string>>;
};

export const useEnterpriseBoostSocial = ({
  setErrorText,
}: useEnterpriseBoostSocialProps) => {
  const client = useQueryClient()
  const {
    mutate: boostEnterpriseSocial,
    isLoading: isBoostEnterpriseSocialLoading,
  } = useMutation({
    mutationFn: (variables: {
      company_id: number | string | undefined;
      token?: string;
    }) =>
      axiosInstance
        .post(enterpriseBoostSocialRoute, variables)
        .then((res) => res.data),

    onMutate: () => {
      setErrorText('');
    },

    onSuccess: (data) => {
      if (data.status === 200) {
        setErrorText('');
        client.invalidateQueries([paymentDetails])
      }
    },
    onError: (error: { response?: { data?: { message?: string } } }) => {
      setErrorText(error?.response?.data?.message || errorMessage);
    },
  });

  return {
    boostEnterpriseSocial,
    isBoostEnterpriseSocialLoading,
  };
};
